import { render, staticRenderFns } from "./albumTemp.vue?vue&type=template&id=19cd7f73&scoped=true"
import script from "./albumTemp.vue?vue&type=script&lang=js"
export * from "./albumTemp.vue?vue&type=script&lang=js"
import style0 from "./albumTemp.vue?vue&type=style&index=0&id=19cd7f73&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd7f73",
  null
  
)

export default component.exports